export const fakeProducts = [
  {
    id: "1",
    name: "Amber Woods",
    description:
      "Wrap yourself in the comforting glow of Amber Woods, where warm amber and smooth sandalwood drift through your space...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
  {
    id: "2",
    name: "Midnight Oak",
    description:
      "Embrace the allure of Midnight Oak, an aroma that conjures moonlit forests shrouded in quiet mystery...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
  {
    id: "3",
    name: "Dark Bourbon",
    description:
      "Indulge in the smooth decadence of Dark Bourbon, where sweet caramel and toasted oak intermingle...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
  {
    id: "4",
    name: "Sandalwood Smoke",
    description:
      "Transport yourself to a hidden sanctuary with Sandalwood Smoke, where velvety sandalwood merges with smoky incense...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
  {
    id: "5",
    name: "Fireside Ember",
    description:
      "Capture the essence of a crackling hearth on a crisp evening with Fireside Ember...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
  {
    id: "6",
    name: "Coastal Drift",
    description:
      "Experience the revitalizing air of Coastal Drift, where bracing sea salt mingles with crisp citrus...",
    price: 40,
    image_url: "https://via.placeholder.com/150",
  },
];
